import { useLocale } from '../i18n/LocaleContext'
import SEOHead from '../components/SEOHead'

export default function Privacy() {
  const { t } = useLocale()

  return (
    <section className="section-padding bg-white">
      <SEOHead title={t.privacy.metaTitle} description={t.privacy.metaDescription} />
      <div className="container-max max-w-3xl">
        <h1 className="mb-2">{t.privacy.title}</h1>
        <p className="text-text-muted text-sm mb-8">{t.privacy.lastUpdated}</p>

        <div className="space-y-8">
          {t.privacy.content.map((section, i) => (
            <div key={i}>
              <h2 className="text-xl font-heading font-medium mb-3">{section.heading}</h2>
              <div className="text-text-secondary leading-relaxed whitespace-pre-line">
                {section.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
